<template>
  <span>&nbsp;v2.0.0</span>
</template>
